var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "table-class": "text-nowrap",
      responsive: "",
    },
    scopedSlots: _vm._u([
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            data.item.is_finished
              ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                  _vm._v("Finished"),
                ])
              : !!data.item.finishes_at
              ? _c("b-badge", { attrs: { variant: "warning" } }, [
                  _vm._v("Stopped"),
                ])
              : data.item.last_paid && !!data.item.last_paid.date_failed
              ? _c("b-badge", { attrs: { variant: "danger" } }, [
                  _vm._v("Payment Failed"),
                ])
              : data.item.last_paid
              ? _c("b-badge", { attrs: { variant: "success" } }, [
                  _vm._v("Active"),
                ])
              : _c("b-badge", { attrs: { variant: "info" } }, [
                  _vm._v("Trial"),
                ]),
          ]
        },
      },
      {
        key: "cell(company)",
        fn: function (data) {
          return [
            _c(
              "h4",
              { staticClass: "mb-0" },
              [
                _c(
                  "b-link",
                  {
                    attrs: {
                      to: {
                        name: "admin-company",
                        params: { id: data.item.company.id },
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(data.item.company.name) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "cell(customer)",
        fn: function (data) {
          return [
            _c(
              "b-link",
              {
                attrs: {
                  to: { name: "admin-user", params: { id: data.item.user.id } },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(data.item.user ? data.item.user.name : "") +
                    "\n      "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "cell(form_of_payment)",
        fn: function (data) {
          return [
            data.item.payment_method
              ? [
                  data.item.payment_method.gateway_type === "auth_net"
                    ? [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.item.payment_method.card_brand) +
                            " ending in " +
                            _vm._s(data.item.payment_method.card_ending) +
                            "\n          "
                        ),
                        _c("div", [
                          _vm._v(
                            "Expires: " +
                              _vm._s(
                                _vm.convertFromUtc(
                                  data.item.payment_method.card_expires,
                                  "MM/YY"
                                )
                              )
                          ),
                        ]),
                      ]
                    : data.item.payment_method.gateway_type === "nuvei"
                    ? [_vm._v("\n          ACH\n        ")]
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(pricing_plan)",
        fn: function (data) {
          return [
            _c(
              "b-link",
              {
                attrs: {
                  to: {
                    name: "admin-pricing-plan-view",
                    params: { id: data.item.pricing_plan.id },
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(data.item.pricing_plan.name) +
                    "\n      "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "cell(charge_amount)",
        fn: function (data) {
          return [
            _vm._v(
              "\n      " +
                _vm._s(_vm.getFormattedPrice(data.item.payment_amount)) +
                "\n      "
            ),
            data.item.pricing_plan.is_recurring_billing
              ? [
                  _vm._v(
                    "\n        (" +
                      _vm._s(
                        _vm.getFormattedRecurringBilling(
                          data.item.pricing_plan.billing_recurrence
                        )
                      ) +
                      ")\n      "
                  ),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(last_charge)",
        fn: function (data) {
          return [
            data.item.last_paid
              ? [
                  data.item.last_paid.date_failed
                    ? [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              _vm.getFormattedPrice(data.item.payment_amount)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v(
                            "failed on " +
                              _vm._s(
                                _vm.convertFromUtc(
                                  data.item.last_paid.date_failed,
                                  "L"
                                )
                              )
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "no-permission-wrapper",
                              { attrs: { show: !_vm.canRetryBillingPayments } },
                              [
                                _c(
                                  "b-btn",
                                  {
                                    attrs: {
                                      type: "button",
                                      variant: "warning",
                                      disabled: !_vm.canRetryBillingPayments,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return (() =>
                                          _vm.retryPayment(data.item)).apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                Retry Payment\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : [
                        data.item.last_paid.amount
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.getFormattedPrice(
                                    data.item.last_paid.amount
                                  )
                                )
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-success" }, [
                          _vm._v(
                            "paid on " +
                              _vm._s(
                                _vm.convertFromUtc(
                                  data.item.last_paid.date,
                                  "L"
                                )
                              )
                          ),
                        ]),
                      ],
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(next_charge)",
        fn: function (data) {
          return [
            data.item.next_payment
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.getFormattedPrice(data.item.next_payment.amount)
                      ) +
                      "\n        "
                  ),
                  _c("div", [
                    _vm._v(
                      "\n          on " +
                        _vm._s(
                          _vm.convertFromUtc(data.item.next_payment.date, "L")
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              : _vm._e(),
          ]
        },
      },
      {
        key: "cell(start)",
        fn: function (data) {
          return [
            _vm._v(
              "\n      " +
                _vm._s(_vm.convertFromUtc(data.item.starts_at, "L")) +
                "\n    "
            ),
          ]
        },
      },
      {
        key: "cell(end)",
        fn: function (data) {
          return [
            data.item.finishes_at
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.convertFromUtc(data.item.finishes_at, "L")) +
                      "\n      "
                  ),
                ]
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }